
import { useState, useEffect } from "react";

import { Route, Switch, Redirect, useLocation } from "react-router-dom";

import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

import Sidenav from "examples/Sidenav";
import theme from "assets/theme";
import routes, { PRINCIPAL_ROUTE_KEYS, SECONDARY_ROUTE_KEYS } from "routes";
import { PrivateRoute, PublicRoute } from "components/PrivateRoute";
import { useVisionUIController, setMiniSidenav } from "context";
import {
  getAccessToken,
  isSecondaryUser,
  getDefaultHomePath,
} from "utils/auth";

export default function App() {
  const [controller, dispatch] = useVisionUIController();
  const { miniSidenav, layout, sidenavColor } = controller;
  const [onMouseEnter, setOnMouseEnter] = useState(false);
  const { pathname } = useLocation();

  const handleOnMouseEnter = () => {
    if (miniSidenav && !onMouseEnter) {
      setMiniSidenav(dispatch, false);
      setOnMouseEnter(true);
    }
  };

  const handleOnMouseLeave = () => {
    if (onMouseEnter) {
      setMiniSidenav(dispatch, true);
      setOnMouseEnter(false);
    }
  };

  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  const getRoutes = (allRoutes) =>
    allRoutes.map((route) => {
      if (route.collapse) {
        return getRoutes(route.collapse);
      }

      if (!route.route) {
        return null;
      }

      if (route.public) {
        return (
          <PublicRoute
            exact
            path={route.route}
            key={route.key}
            component={route.component}
          />
        );
      }

      return (
        <PrivateRoute
          exact
          path={route.route}
          key={route.key}
          component={route.component}
          principalOnly={Boolean(route.principalOnly)}
        />
      );
    });

  const loggedIn = Boolean(getAccessToken());

  const sidenavRoutes = routes.filter((route) => {
    if (route.type !== "collapse" || route.public) {
      return false;
    }
    if (!loggedIn) {
      return false;
    }
    if (isSecondaryUser()) {
      return SECONDARY_ROUTE_KEYS.includes(route.key);
    }
    return PRINCIPAL_ROUTE_KEYS.includes(route.key) || route.key === "profile";
  });

  const redirectTarget = loggedIn ? getDefaultHomePath() : "/authentication/sign-in";

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {layout === "dashboard" && loggedIn && (
        <Sidenav
          color={sidenavColor}
          brand=""
          brandName="CuentaMeloN"
          routes={sidenavRoutes}
          onMouseEnter={handleOnMouseEnter}
          onMouseLeave={handleOnMouseLeave}
        />
      )}
      <Switch>
        <Route exact path="/" render={() => <Redirect to={redirectTarget} />} />
        {getRoutes(routes)}
        <Redirect from="*" to={redirectTarget} />
      </Switch>
    </ThemeProvider>
  );
}
